module.exports = __webpack_public_path__ + "img/user-2-banner.08647f6e.jpeg";